// Lấy danh sách sổ tiết kiệm
export const FETCH_TERM_DEPOSIT_LIST_REQUEST = "FETCH_TERM_DEPOSIT_LIST_REQUEST";
export const FETCH_TERM_DEPOSIT_LIST_SUCCESS = "FETCH_TERM_DEPOSIT_LIST_SUCCESS";
export const FETCH_TERM_DEPOSIT_LIST_FAILURE = "FETCH_TERM_DEPOSIT_LIST_FAILURE";
